import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

import VideoTutorialRow from '@/components/VideoTutorialRow';
import VideoTutorialsModal from '@/components/VideoTutorialsModal';
import WatchTutorialsButton from '@/components/WatchTutorialsButton';

import type { ContractTutorialsState } from '@/types/videoTutorials';

interface ContractTutorialsProps {
  state: ContractTutorialsState;
}

const ContractTutorials = ({ state }: ContractTutorialsProps) => {
  const { t } = useTranslation();
  const {
    tutorials,
    operationTutorial,
    partnerName,
    link,
    isDemo,
    isModalOpen,
    modalEntry,
    showOperationTutorial,
    showWatchTutorials,
    openOperationTutorial,
    openAllTutorials,
    closeModal,
    handlePlay,
    handlePartnerAccess,
  } = state;

  if (!link || tutorials.length === 0) return null;

  return (
    <>
      {showOperationTutorial && operationTutorial && (
        <VideoTutorialRow
          title={t(`videoTutorials.tutoTitle.${operationTutorial.operation}`, { partnerName })}
          duree={operationTutorial.duree}
          onClick={openOperationTutorial}
        />
      )}
      {showWatchTutorials && <WatchTutorialsButton partnerName={partnerName} onClick={openAllTutorials} />}
      {createPortal(
        <VideoTutorialsModal
          isOpen={isModalOpen}
          onClose={closeModal}
          entry={modalEntry}
          partnerName={partnerName}
          onPlay={handlePlay}
          onPartnerAccess={handlePartnerAccess}
          isPartnerAccessDisabled={isDemo}
        />,
        document.body
      )}
    </>
  );
};

export default ContractTutorials;
